/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { AbloeseAktDataStatusResponse } from '../models/abloese-akt-data-status-response';
import { FairAppRequest } from '../models/fair-app-request';
@Injectable({
  providedIn: 'root',
})
class StatusService extends __BaseService {
  static readonly statusCreatePath = '/status';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param data undefined
   */
  statusCreateResponse(data: FairAppRequest): __Observable<__StrictHttpResponse<AbloeseAktDataStatusResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/status`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AbloeseAktDataStatusResponse>;
      })
    );
  }
  /**
   * @param data undefined
   */
  statusCreate(data: FairAppRequest): __Observable<AbloeseAktDataStatusResponse> {
    return this.statusCreateResponse(data).pipe(
      __map(_r => _r.body as AbloeseAktDataStatusResponse)
    );
  }
}

module StatusService {
}

export { StatusService }
